import { combineReducers } from "redux";
import { Package } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_PACKAGE_REQUEST, UPDATE_PACKAGE_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<Package> = {}, action: Action): Partial<Package> {
  switch (action.type) {
    case getSuccessActionType(FETCH_PACKAGE_REQUEST):
    case getSuccessActionType(UPDATE_PACKAGE_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PACKAGE_REQUEST:
    case UPDATE_PACKAGE_REQUEST:
      return true;

    case getSuccessActionType(FETCH_PACKAGE_REQUEST):
    case getFailureActionType(FETCH_PACKAGE_REQUEST):
    case getSuccessActionType(UPDATE_PACKAGE_REQUEST):
    case getFailureActionType(UPDATE_PACKAGE_REQUEST):
      return false;
    default:
      return state;
  }
}

export const packageItem = combineReducers({ item, isFetching });
